import { render } from "./BaseAlert.vue?vue&type=template&id=00e503b3&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"

import "./BaseAlert.vue?vue&type=style&index=0&id=00e503b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e503b3"]])

export default __exports__